var render = function () {
  var _vm$application$appli, _vm$application$appli2, _vm$application$appli3, _vm$application$appli4, _vm$application$appli5, _vm$application$appli6, _vm$application$appli7;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "value": _vm.dialog,
      "max-width": "1100",
      "persistent": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline accent--text pb-4"
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")]), _c('transition', {
    attrs: {
      "name": "animation"
    }
  }, [_vm.dialog ? _c('v-card-text', {
    staticClass: "border-top py-6",
    attrs: {
      "outlined": "",
      "tile": ""
    }
  }, [[1, 2].includes((_vm$application$appli = _vm.application.applicationType) === null || _vm$application$appli === void 0 ? void 0 : _vm$application$appli.id) ? _c('IdentityCardComponent', {
    attrs: {
      "item": _vm.identityCardParent
    },
    on: {
      "set-data": function setData($event) {
        _vm.identityCardParent = $event;
      },
      "remove": _vm.removeIdentityCard
    }
  }) : _vm._e(), ((_vm$application$appli2 = _vm.application.applicationType) === null || _vm$application$appli2 === void 0 ? void 0 : _vm$application$appli2.id) === 1 ? _c('ApplicationRecoveryComponent', {
    attrs: {
      "item": _vm.application
    },
    on: {
      "set-data": function setData($event) {
        _vm.application = $event;
      }
    }
  }) : _vm._e(), ((_vm$application$appli3 = _vm.application.applicationType) === null || _vm$application$appli3 === void 0 ? void 0 : _vm$application$appli3.id) === 2 ? _c('ApplicationOrganizationTransferComponent', {
    attrs: {
      "item": _vm.application
    },
    on: {
      "set-data": function setData($event) {
        _vm.application = $event;
      }
    }
  }) : _vm._e(), ((_vm$application$appli4 = _vm.application.applicationType) === null || _vm$application$appli4 === void 0 ? void 0 : _vm$application$appli4.id) === 3 ? _c('ApplicationEducationTransferComponent', {
    attrs: {
      "item": _vm.application
    },
    on: {
      "set-data": function setData($event) {
        _vm.application = $event;
      }
    }
  }) : _vm._e(), _c('TrainingCertificateComponent', {
    attrs: {
      "item": _vm.trainingCertificateParent
    },
    on: {
      "set-data": function setData($event) {
        _vm.trainingCertificateParent = $event;
      },
      "remove": _vm.removeTrainingCertificate
    }
  }), ((_vm$application$appli5 = _vm.application.applicationType) === null || _vm$application$appli5 === void 0 ? void 0 : _vm$application$appli5.id) === 1 ? _c('EducationComponent', {
    attrs: {
      "item": _vm.educationParent
    },
    on: {
      "set-data": function setData($event) {
        _vm.educationParent = $event;
      },
      "remove": _vm.removeEducation
    }
  }) : _vm._e(), ((_vm$application$appli6 = _vm.application.applicationType) === null || _vm$application$appli6 === void 0 ? void 0 : _vm$application$appli6.id) === 1 ? _c('MedicalCertificateComponent', {
    attrs: {
      "item": _vm.medicalCertificateParent
    },
    on: {
      "set-data": function setData($event) {
        _vm.medicalCertificateParent = $event;
      },
      "remove": _vm.removeMedicalCertificate
    }
  }) : _vm._e(), ((_vm$application$appli7 = _vm.application.applicationType) === null || _vm$application$appli7 === void 0 ? void 0 : _vm$application$appli7.id) === 1 ? _c('MilitaryComponent', {
    attrs: {
      "item": _vm.militaryParent
    },
    on: {
      "set-data": function setData($event) {
        _vm.militaryParent = $event;
      },
      "remove": _vm.removeMilitary
    }
  }) : _vm._e(), _c('AchievementComponent', {
    attrs: {
      "item": _vm.achievementParent
    },
    on: {
      "set-data": function setData($event) {
        _vm.achievementParent = $event;
      },
      "remove": _vm.removeAchievement
    }
  })], 1) : _vm._e()], 1), _c('v-card-actions', {
    staticClass: "border-top px-6"
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "lightGrey",
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Закрыть")]), _c('v-btn', {
    attrs: {
      "disabled": _vm.disabledBtn,
      "loading": _vm.loading,
      "color": "success",
      "text": ""
    },
    on: {
      "click": _vm.saveData
    }
  }, [_vm._v(" Сохранить ")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }